import React, { useEffect } from "react";
// import OwlCarousel from 'react-owl-carousel';
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import ArrowLeftLineIcon from "remixicon-react/ArrowLeftLineIcon";
import { Link } from "react-router-dom";
import AuthActions from "../redux/auth/actions";
import Button from "../components/utils/Button";
import Alert from "../components/utils/Alert";
import mailIcon from "../assets/images/mail.png";
import Long from "../../src/assets/images/USACANADA_LOGO.png";
import Style from "./ForgetPassword.module.css";

const { forgetPassword, authReset } = AuthActions;

const ForgetPassword = () => {
  const dispatch = useDispatch();
  const Auth = useSelector((state) => state.auth);
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  useEffect(() => {
    dispatch(authReset());
  }, []);

  const handleForgetPassword = (data) => {
    dispatch(forgetPassword(data));
  };

  return (
    <section className={Style.page}>
      <div className={Style.shell}>
        {/* Brand panel — same as Signin */}
        <div className={Style.brandPanel}>
          <div className={Style.logoBadge}>
            <img src={Long} alt="Logo" />
          </div>
          <div className={Style.brandCopy}>
            <p className={Style.brandEyebrow}>Admin console</p>
            <h2 className={Style.brandTitle}>
              Manage plans, subscribers,
              <br />
              and billing — all in one place.
            </h2>
          </div>
          <p className={Style.brandFooter}>
            © {new Date().getFullYear()} Chatr Portal
          </p>
        </div>

        {/* Form panel */}
        <div className={Style.formPanel}>
          {!Auth.forgetPasswordMessage ? (
            <Link to={"/sign-in"} className={Style.backBtn}>
              <ArrowLeftLineIcon size={18} />
            </Link>
          ) : (
            ""
          )}

          {Auth.forgetPasswordMessage ? (
            <div className={Style.successWrap}>
              <div className={Style.successIcon}>
                <img src={mailIcon} alt="" />
              </div>
              <h1 className={Style.successTitle}>Success!</h1>
              <p className={Style.successText}>
                Please check your email to reset your password.
              </p>
              <Link to="/sign-in" className={Style.backHomeBtn}>
                Back to sign in
              </Link>
            </div>
          ) : (
            <div>
              <div className={Style.formHead}>
                <h1 className={Style.welcome}>Forgot password</h1>
                <p className={Style.subtext}>
                  Enter your username and we'll send you an email with
                  instructions to reset your password.
                </p>
              </div>

              {Auth.forgetPasswordError ? (
                <Alert type="alert-danger" text={Auth.forgetPasswordError} />
              ) : (
                ""
              )}

              <form onSubmit={handleSubmit(handleForgetPassword)}>
                <div className={Style.field}>
                  <label className={Style.fieldLabel} htmlFor="username">
                    Username
                  </label>
                  <input
                    id="username"
                    type="text"
                    className={`${Style.inputEl} ${errors.username ? Style.inputElError : ""}`}
                    name="username"
                    {...register("username", { required: true })}
                    placeholder="Enter username"
                  />
                  {errors.username && errors.username.type === "required" ? (
                    <p className={Style.errorText}>Username is required</p>
                  ) : (
                    ""
                  )}
                </div>

                <Button
                  title="Reset Password"
                  buttonClass={Style.submitBtn}
                  loading={Auth.forgetPasswordLoading}
                  buttonType="submit"
                />
              </form>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default ForgetPassword;
